export const mapToOptions = (items, keyMap) => {
  if (!items || !Array.isArray(items)) return [];

  return items.map((item) => {
    const option = {
      value: item[keyMap.value],
      label: item[keyMap.label],
      firstName: item[keyMap?.firstName],
      lastName: item[keyMap?.lastName],
    };

    // Add additional fields if specified
    if (keyMap.additionalFields) {
      Object.keys(keyMap.additionalFields).forEach((field) => {
        option[field] = item[keyMap.additionalFields[field]];
      });
    }

    return option;
  });
};
